const initialState = {
  status: "invalid",
  data: null
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "COURSE_MODULE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "COURSE_MODULE_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
      };
    case "COURSE_MODULE_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
